import React from "react";
import { Breadcrumb } from "../../../components/Breadcrumb";

export const Debts = () => {
    document.title = "Borclar";

    const menu = [
        { name: "Ana səhifə", value: "/" },
        { name: "Hesabatlar", value: "/reports" },
        { name: "Borclar", value: "/reports/debts" },
    ];

    return (
        <div>
            <Breadcrumb menu={menu} />
            <div className="container">
                <article>
                    <h2 className="my-4">Borclar</h2>
                    <p>
                        Alacaq-Verəcək borclar barədə məlumat əldə etmək üçün nəzərdə tutulub.
                        <br />
                        Nümunədə Hesabatlar ⮞ Borclar səhifəsinə baxmaq üçün ardıcıllıq göstərilib
                    </p>
                    <img src="/images/reports/debts-1.gif" alt="Borclar" />
                    <h2 className="my-4">Üzləşmə aktı</h2>
                    <p>
                        Müştərilərlə icra edilən bütün əməliyyatların ( sənədlərin ) çıxarışıdır. Tərəf müqabilə <b>verilən</b> (satış, məxaric, alışın
                        qaytarması ) və <b>alınan</b> ( alış, mədaxil, satışın geri qaytarması) əməliyyatlar nəticəsində seçilmiş tarix aralığına görə
                        formalaşan borcun <mark>üzləşmə aktı</mark>.
                        <br />
                        Nümunədə Hesabatlar ⮞ Borclar ⮞ Üzləşmə səhifəsinə baxmaq üçün ardıcıllıq göstərilib
                    </p>
                    <img src="/images/reports/debts-2.gif" alt="Borclar" />
                </article>
            </div>
        </div>
    );
};
